import { ouibounce } from './ouibounce-popup';
const cookeUtil = require('./cooke-util');
const contextPath = $('meta[name=context-path]').attr('content');
const cookeName = 'abandonedCart';